import React from "react";
import { Link } from "react-router-dom";

const Card = ({ imageSrc, title, description , categoryId }) => {
  return (
    <div className="p-2 h-[269px] w-[269px] bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col justify-between">
      <img
        className="rounded-t-lg w-full h-[130.11px] object-cover"
        src={imageSrc}
        alt={title}
      />
      <div className="w-full h-full p-5 pb-0 text-2xl text-left font-bold tracking-tight flex flex-col justify-between">
        <a
          href={`#${categoryId}`}
          className="text-[#005CB9] text-left font-bold text-lg md:text-xl"
        >
          <p>{title}</p>
        </a>
        <div className="flex-grow"></div>{" "}
        {/* Add this line href push the arrow a href the bothrefm */}
        <a
          href={`#${categoryId}`}
          className="text-[#005CB9] text-lg md:text-xl text-right mt-auto"
        >
          <i className="fa-solid fa-arrow-right" style={{ fontSize: 20 }}></i>{" "}
          {/* Increased icon size */}
        </a>
      </div>
    </div>
  );
};

const HeroProductsFilter = ({ categoriesField = [] }) => {
  return (
    <div className="mx-auto w-[82%] flex items-center justify-center md:justify-between flex-wrap gap-4">
      {/* <p onClick={()=>console.log(categoriesField)}>dfkwoejf</p> */}
      {
        categoriesField.map((category)=>(
          <Card
          key={category?.value}
          categoryId={category?.value}
          title={
            <>
              <h3 className="lg:text-[16px] text-[14px] leading-[24.32px]">
                {category?.name}
              </h3>
            </>
          }
          imageSrc={category?.image ? category.image : require("../../../assets/Products/Cardiovascular.png")}
        />
        ))
      }
    </div>
  );
};

export default HeroProductsFilter;
